module.exports = __webpack_public_path__ + "img/gnzs18.4a2e0209.png";